import React, { Component } from 'react';
import { toast } from 'react-toastify';
import voca from 'voca';
import RestAPICollectionFieldsModal from '../../external-api/rest-api/RestAPICollectionFieldsModal';
export default class RestClientParamRow extends Component {
  static propTypes = {};

  state = {
    paramKey: this.props.paramRow.key,
    paramValue: this.props.paramRow.value,
    showModalForCollectionFields: false,
  };
  deleteRow = () => {
    this.setState({
      paramKey: '',
      paramValue: '',
    });
    this.props.paramRow.key = '';
    this.props.paramRow.value = '';
  };
  toggleFieldsModal = () => {
    this.setState({ showModalForCollectionFields: !this.state.showModalForCollectionFields });
  };

  copyToClipboard = () => {
    this.setState({
      copied: true,
      showModalForCollectionFields: !this.state.showModalForCollectionFields,
    });
    toast.success('Copied to clipboard');
    setTimeout(() => {
      this.setState({ copied: false });
    }, 2000);
  };

  insertTextToParamInput = (textToInsert) => {
    if (textToInsert) {
      const queryParamInputElem = document.getElementById(`paramValue${this.props.paramRow.id}`);
      let start = queryParamInputElem.selectionStart;
      // obtain the index of the last selected character
      let finish = queryParamInputElem.selectionEnd;
      //obtain all Text
      let allText = queryParamInputElem.value;
      // obtain the selected text
      let sel = allText.substring(start, finish);
      let newText = '';
      if (sel) {
        newText = allText.replace(sel, textToInsert);
      } else {
        newText = allText + textToInsert;
      }

      this.setState({
        showModalForCollectionFields: !this.state.showModalForCollectionFields,
        paramValue: newText,
      });
      this.props.paramRow.value = newText;
      toast.success('Inserted into Query Parameter Value');
    }
  };

  showCollectionFieldModal = () => {
    const { collectionName, bodyDataFrom, externalapi, home } = this.props;
    const { collections } = externalapi ? externalapi : '';
    const { projectDetail, iPlugins } = home ? home : '';
    const selectedCollection =
      collectionName &&
      collections &&
      collections.find((collection) => {
        return collection.collectionName === collectionName;
      });
    let tenantCollectionId = '';
    let userSettingCollectionId = '';
    let subTenantCollectionId = '';
    const multiTenantPlugin = iPlugins.find((e) => e.code === 'MULTI_TENANT_SAAS');
    if (multiTenantPlugin) {
      tenantCollectionId = multiTenantPlugin.setting.multiTenantCollection;
      userSettingCollectionId = multiTenantPlugin.setting.userSettingsCollection || '';
      subTenantCollectionId = multiTenantPlugin.setting.subTenantCollection || '';
    }
    return (
      <RestAPICollectionFieldsModal
        selectedCollection={selectedCollection}
        collections={collections}
        projectDetail={projectDetail}
        copyToClipboard={this.copyToClipboard}
        insertTextToEditor={this.insertTextToParamInput}
        toggleFields={this.state.showModalForCollectionFields}
        toggleFieldsModal={this.toggleFieldsModal}
        bodyDataFrom={bodyDataFrom}
        tenantCollectionId={tenantCollectionId}
        userSettingCollectionId={userSettingCollectionId}
        subTenantCollectionId={subTenantCollectionId}
        hide={['tenantDerivedFields', 'userSettingDerivedFields', 'subTenantDerivedFields']}
      />
    );
  };

  onKeyChange = (e) => {
    this.setState({
      ...this.state,
      paramKey: voca.trim(e.target.value),
    });

    this.props.paramRow.key = voca.trim(e.target.value);
    this.props.createNewRow(this.props.paramRow);
  };

  onValueChange = (e) => {
    this.setState({
      ...this.state,
      paramValue: e.target.value,
    });
    this.props.paramRow.value = e.target.value;
    this.props.createNewRow(this.props.paramRow);
  };

  render() {
    return (
      <>
        {this.state.showModalForCollectionFields && this.showCollectionFieldModal()}
        <div className="col-md-4 col-lg-4">
          <input
            type="text"
            name="paramKey"
            value={this.state.paramKey}
            className="form-control form-control-sm"
            onChange={this.onKeyChange}
            placeholder="Key"
          />
        </div>
        <div className="col-md-8 col-lg-8">
          <div className="input-group">
            <input
              type="text"
              name="paramValue"
              value={this.state.paramValue}
              className="form-control form-control-sm"
              onChange={this.onValueChange}
              placeholder="Value"
              id={`paramValue${this.props.paramRow.id}`}
            />
            <div className="input-group-append">
              <span className="input-group-text">
                <button
                  type="button"
                  className="btn btn-theme-submit btn-xs btn-icon-only"
                  title="Add Fields"
                  onClick={() => {
                    this.toggleFieldsModal();
                  }}
                >
                  <i className="wb webconnect-plus" />
                </button>
                <button
                  type="button"
                  className="btn btn-xs btn-theme-delete btn-icon-only ml-1"
                  title="Delete Fields"
                  onClick={() => {
                    this.deleteRow();
                  }}
                >
                  <i className="wb webconnect-times " />
                </button>
              </span>
            </div>
          </div>
        </div>
      </>
    );
  }
}
